const baseUrl = '/credentials';
export const credentialsRoutes = {
  baseUrl: "".concat(baseUrl),
  credentialsById: credentialsId => "".concat(baseUrl, "/").concat(credentialsId),
  credentialsUsersById: credentialsId => "".concat(baseUrl, "/").concat(credentialsId, "/users"),
  credentialsPropertiesById: credentialsId => "".concat(baseUrl, "/").concat(credentialsId, "/properties"),
  credentialsGlAccountsById: credentialsId => "".concat(baseUrl, "/").concat(credentialsId, "/gl-accounts"),
  glAccounts: "glaccounts/gl-accounts",
  properties: "properties",
  propertiesById: propertyLivableId => "properties/".concat(propertyLivableId),
  pendingBatches: propertyLivableId => "properties/".concat(propertyLivableId, "/pending-batches"),
  pendingBatchesById: (propertyLivableId, batchExternalId) => "properties/".concat(propertyLivableId, "/pending-batches/").concat(batchExternalId)
};